<template>
  <v-form @submit.prevent>
      <tiles-form :tile="doc" />
      <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form"
import router from "@/router";

export default {
  name: "AdminPictosAdd",
  components: {
    TilesForm
  },
  data () {
    return {
      doc: {}
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let ref = this.$parent.collection.doc();
      ref.set({
        createdOn: new Date(),
        id: ref.id,
        title_en: this.populateField(this.doc.title_en),
        title_ar: this.populateField(this.doc.title_ar),
        title_fr: this.populateField(this.doc.title_fr),
        description_en: this.populateField(this.doc.description_en),
        description_ar: this.populateField(this.doc.description_ar),
        description_fr: this.populateField(this.doc.description_fr),
        src: this.populateField(this.doc.src)
      }).then(() => {
        router.push({ name: this.$parent.returnRoute })
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    },
    populateField(field) {
      return field ? field : null
    }
  }
};
</script>
